import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit'

import { RootState } from '@/redux/store'

export interface RelationshipSetupState {
  isDismissed: boolean
  isManuallyOpen: boolean
}

const INITIAL_STATE: RelationshipSetupState = {
  isDismissed: false,
  isManuallyOpen: false,
}

const relationshipSetup = createSlice({
  name: 'relationshipSetup',
  initialState: INITIAL_STATE,
  reducers: {
    setRelationshipSetupDismissed: (state, action: PayloadAction<boolean>) => {
      state.isDismissed = action.payload
    },

    setRelationshipSetupManuallyOpen: (
      state,
      action: PayloadAction<boolean>,
    ) => {
      state.isManuallyOpen = action.payload
    },
  },
})

export const {
  setRelationshipSetupDismissed,
  setRelationshipSetupManuallyOpen,
} = relationshipSetup.actions

export const selectRelationshipSetup = (state: RootState) =>
  state.relationshipSetup

export const selectRelationshipSetupDismissed = createSelector(
  selectRelationshipSetup,
  (relationshipSetup) => relationshipSetup.isDismissed,
)

export const selectRelationshipSetupManuallyOpen = createSelector(
  selectRelationshipSetup,
  (relationshipSetup) => relationshipSetup.isManuallyOpen,
)

export const relationshipSetupReducer = relationshipSetup.reducer
